import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';

import { TransferCouponCodeService } from '../../../services/index';

declare var swal: any;

@Component({
    selector: 'addEditTransferCouponCode',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './addEditTransferCouponCode.component.html'
})

export class AddEditTransferCouponCodeComponent implements OnInit {
    public title: string;
    public onClose: Subject<boolean>;
    public transferData: any = {
        from_client_no: '',
        from_client_name: '',
        to_client_no: '',
        to_client_name: '',
        remarks: '',
        from_client_id: '',
        to_client_id: '',
    };
    public couponCodeList: any[] = [];
    public selectedCouponCode: string = '';
    public isLoading: boolean = false;

    // Search functionality
    private fromClientSearchTerms = new Subject<string>();
    private toClientSearchTerms = new Subject<string>();
    public fromClientList: any[] = [];
    public toClientList: any[] = [];
    public showFromClientDropdown: boolean = false;
    public showToClientDropdown: boolean = false;
    public fromClientSearchText: string = '';
    public toClientSearchText: string = '';

    constructor(
        public bsModalRef: BsModalRef,
        public transferCouponCodeService: TransferCouponCodeService
    ) { }

    ngOnInit() {
        this.onClose = new Subject();

        // Setup From Client search
        this.fromClientSearchTerms
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term && term.length >= 1
                ? this.transferCouponCodeService.searchClientsForTransfer(term)
                : Observable.of({ success: false, data: [] }))
            .subscribe((response: any) => {
                if (response && response.success && response.data && response.data.length > 0) {
                    this.fromClientList = response.data;
                    this.showFromClientDropdown = true;
                } else {
                    this.fromClientList = [];
                    this.showFromClientDropdown = false;
                }
            });

        // Setup To Client search
        this.toClientSearchTerms
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term && term.length >= 1
                ? this.transferCouponCodeService.searchClientsForTransfer(term)
                : Observable.of({ success: false, data: [] }))
            .subscribe((response: any) => {
                if (response && response.success && response.data && response.data.length > 0) {
                    this.toClientList = response.data;
                    this.showToClientDropdown = true;
                } else {
                    this.toClientList = [];
                    this.showToClientDropdown = false;
                }
            });
    }

    transferCouponCode() {
        if (!this.transferData.from_client_id) {
            swal('Error', 'Please select From Client', 'error');
            return;
        }

        if (!this.transferData.to_client_id) {
            swal('Error', 'Please select To Client', 'error');
            return;
        }

        if (this.transferData.from_client_id == this.transferData.to_client_id) {
            swal('Error', 'From Client and To Client cannot be the same', 'error');
            return;
        }

        if (!this.selectedCouponCode) {
            swal('Error', 'Please select a Coupon Code', 'error');
            return;
        }

        this.isLoading = true;
        const payload = {
            from_client_id: this.transferData.from_client_id,
            to_client_id: this.transferData.to_client_id,
            coupon_code: this.selectedCouponCode,
            remarks: this.transferData.remarks
        };

        this.transferCouponCodeService.transferCouponCode(payload).then((data: any) => {
            this.isLoading = false;
            if (data.success) {
                swal('Success', data.message, 'success');
                this.onClose.next(true);
                this.bsModalRef.hide();
            } else {
                swal('ERROR', data.message, 'error');
            }
        }).catch((err: any) => {
            console.log(err);
            this.isLoading = false;
            swal('ERROR', 'Failed to transfer coupon code', 'error');
        });
    }

    close() {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    // From Client search
    searchFromClient(query: string) {
        this.fromClientSearchText = query;
        this.fromClientSearchTerms.next(query);
    }

    onSelectFromClient(client: any) {
        this.transferData.from_client_no = client.client_no;
        this.transferData.from_client_name = client.client_name;
        this.transferData.from_client_id = client.client_id;
        this.fromClientSearchText = client.client_no;
        this.showFromClientDropdown = false;

        // Load coupon codes for selected from client
        this.couponCodeList = [];
        this.selectedCouponCode = '';
        this.transferCouponCodeService.getClientCouponCodes(client.client_id).then((data: any) => {
            if (data.success && data.data) {
                this.couponCodeList = data.data;
            }
        }).catch((err: any) => {
            console.log(err);
        });
    }

    // To Client search
    searchToClient(query: string) {
        this.toClientSearchText = query;
        this.toClientSearchTerms.next(query);
    }

    onSelectToClient(client: any) {
        this.transferData.to_client_no = client.client_no;
        this.transferData.to_client_name = client.client_name;
        this.transferData.to_client_id = client.client_id;
        this.toClientSearchText = client.client_no;
        this.showToClientDropdown = false;
    }

    clearFromClient() {
        this.transferData.from_client_no = '';
        this.transferData.from_client_name = '';
        this.fromClientSearchText = '';
        this.transferData.from_client_id = '';
        this.fromClientList = [];
        this.showFromClientDropdown = false;
        this.couponCodeList = [];
        this.selectedCouponCode = '';
    }

    clearToClient() {
        this.transferData.to_client_no = '';
        this.transferData.to_client_name = '';
        this.toClientSearchText = '';
        this.transferData.to_client_id = '';
        this.toClientList = [];
        this.showToClientDropdown = false;
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/transferCouponCode/addEditTransferCouponCode.component.ts